import React, {Component} from 'react';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import Snackbar from '@material-ui/core/Snackbar';
import {Row, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import {loadDsList, loadDsDetails} from '../../common-redux/common.actions';
import Button from '../../components/button';
import OneOptAutocomplete from '../recon/components/oneopt-autocomplete';
import Dropdown from '../../components/dropdown'; // eslint-disable-line no-unused-vars
import TextEditField from '../../components/textfield'; // eslint-disable-line no-unused-vars
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Modal from '../../components/modal';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const getFieldLineageKey = (useCaseName, fieldName) => `fieldLineageDraft_${useCaseName || ''}_${fieldName || ''}`;

class FieldLineage extends Component {
  // componentDidUpdate removed to avoid duplicate API calls
  state = {
    ...this.state,
    dsError: '',
    fieldError: '',
    aliasError: '',
    dsTouched: false,
    fieldTouched: false,
    aliasTouched: false,
  };
  handleToggleCollapse = (idx) => {
    this.setState((prevState) => {
      const rows = prevState.rows || [];
      const row = rows[idx];
      if (!row) return {};
      const collapsedRows = {...prevState.collapsedRows};
      const isCollapsing = !collapsedRows[row.id];
      collapsedRows[row.id] = isCollapsing;
      if (isCollapsing) {
        // Collapse all descendants
        const parentIndent = row.indent || 0;
        for (let i = idx + 1; i < rows.length; i++) {
          if ((rows[i].indent || 0) > parentIndent) {
            collapsedRows[rows[i].id] = true;
          } else {
            break;
          }
        }
      }
      return {collapsedRows};
    });
  };
  state = {
    showDeleteModal: false,
    deleteRowIdx: null,
    collapsedRows: {},
    ...this.state,
  };

  handleMenuOpen = (event, idx) => {
    this.setState({menuRowIdx: idx, menuAnchorEl: event.currentTarget});
  };

  handleMenuClose = () => {
    this.setState({menuRowIdx: null, menuAnchorEl: null});
  };

  handleDeleteClick = (idx) => {
    // Count child hops for the row to be deleted
    const {rows} = this.state;
    let childCount = 0;
    if (rows && rows[idx] && typeof rows[idx].indent === 'number') {
      const parentIndent = rows[idx].indent || 0;
      for (let i = idx + 1; i < rows.length; i++) {
        if ((rows[i].indent || 0) > parentIndent) {
          childCount++;
        } else {
          break;
        }
      }
    }
    this.setState({showDeleteModal: true, deleteRowIdx: idx, menuRowIdx: null, deleteChildCount: childCount});
  };

  handleDeleteCancel = () => {
    this.setState({showDeleteModal: false, deleteRowIdx: null});
  };

  handleDeleteConfirm = () => {
    const {deleteRowIdx, rows, useCaseName, fieldName} = this.state;
    if (deleteRowIdx !== null && rows && rows.length > deleteRowIdx) {
      // Find all children (hops) of the row to be deleted
      const parentIndent = rows[deleteRowIdx].indent || 0;
      let endIdx = deleteRowIdx + 1;
      while (endIdx < rows.length && (rows[endIdx].indent || 0) > parentIndent) {
        endIdx++;
      }
      // Remove the parent and all its children
      const updatedRows = rows.filter((_, i) => i < deleteRowIdx || i >= endIdx);
      // Save nested lineageRows to localStorage so refresh works
      const lineageRows = this.nestLineageRows(updatedRows);
      const lineageJson = {lineageRows};
      this.setState({
        rows: updatedRows,
        showDeleteModal: false,
        deleteRowIdx: null,
        deleteChildCount: 0,
        selectedRow: null,
        showPanel: true,
        panelRow: null,
        isNewPanelRow: false,
      }, () => {
        try {
          const key = `fieldLineageDraft_${useCaseName || ''}_${fieldName || ''}`;
          localStorage.setItem(key, JSON.stringify(lineageJson));
        } catch (e) {}
      });
    } else {
      this.setState({showDeleteModal: false, deleteRowIdx: null, deleteChildCount: 0, selectedRow: null, showPanel: true, panelRow: null, isNewPanelRow: false}); // eslint-disable-line max-len
    }
  };
  constructor(props) {
    super(props);
    this.panelChanged = false;
    const {useCaseName, fieldName} = props.location.state || {};
    let initial = {
      useCaseName: useCaseName || '',
      fieldName: fieldName || '',
      rows: [
        {
          id: 1,
          source: '',
          target: useCaseName || '',
          dataSource: '',
          hops: [],
          highlight: false,
          status: null,
        },
      ],
      selectedRow: null,
      showPanel: true,
      panelRow: null,
      selectedDataSource: null,
      selectedField: null,
      aliasName: '',
      isOrigin: false,
    };
    // Restore from localStorage if present, else initialize from new-lineage draft if available
    try {
      const key = getFieldLineageKey(useCaseName, fieldName);
      const saved = localStorage.getItem(key);
      if (saved) {
        const parsed = JSON.parse(saved);
        // If nested lineageRows exists, flatten it
        if (parsed.lineageRows) {
          initial.rows = this.flattenLineageRows(parsed.lineageRows);
        } else {
          initial = {...initial, ...parsed};
        }
      } else {
        // Try to initialize from new-lineage draft field if available
        const lineageDraft = localStorage.getItem('dataLineageNewDraft');
        if (lineageDraft) {
          const parsed = JSON.parse(lineageDraft);
          if (parsed && parsed.fields && Array.isArray(parsed.fields)) {
            const field = parsed.fields.find((f) => f.name === fieldName);
            if (field) {
              // Use field name as source, useCaseName as target
              initial.rows = [
                {
                  id: 1,
                  source: field.name,
                  target: useCaseName || '',
                  dataSource: '',
                  hops: [],
                  highlight: false,
                },
              ];
              initial.aliasName = field.name;
            }
          }
        }
      }
    } catch (e) {}
    this.state = {
      ...initial,
      snackbarOpen: false,
      snackbarMsg: '',
    };

    this.handleDataSourceChange = this.handleDataSourceChange.bind(this);
    this.handleOriginChange = (event, isChecked) => {
      this.setState({isOrigin: isChecked});
    };
  }

  // Helper to flatten nested lineageRows to flat rows array
  flattenLineageRows = (nestedRows, parentIndent = 0) => {
    let result = [];
    nestedRows.forEach((row) => {
      const {hops, ...rowData} = row;
      result.push({...rowData, indent: parentIndent});
      if (hops && hops.length > 0) {
        result = result.concat(this.flattenLineageRows(hops, parentIndent + 16));
      }
    });
    return result;
  };

  // Helper to nest hops by indent
  nestLineageRows = (rows) => {
    if (!rows || rows.length === 0) return [];
    const result = [];
    const stack = [];
    rows.forEach((row) => {
      const rowCopy = {...row, hops: []};
      while (stack.length && (row.indent || 0) <= (stack[stack.length - 1].indent || 0)) {
        stack.pop();
      }
      if (stack.length) {
        stack[stack.length - 1].hops.push(rowCopy);
      } else {
        result.push(rowCopy);
      }
      stack.push(rowCopy);
    });
    return result;
  };

  saveDraft = (nextState) => {
    const {useCaseName, fieldName} = this.state;
    try {
      localStorage.setItem(getFieldLineageKey(useCaseName, fieldName), JSON.stringify(nextState || this.state));
    } catch (e) {}
  };

  componentDidMount() {
    document.getElementById('app').scrollTo(0, 0);
    if (!this.props.dsList || this.props.dsList.length === 0) {
      this.props.loadDsList();
    }
    // Always check first row for saved dataSource and make API call
    const firstRow = this.state.rows && this.state.rows[0];
    if (firstRow && firstRow.dataSource) {
      let dsObj = null;
      if (typeof firstRow.dataSource === 'object' && firstRow.dataSource.id) {
        dsObj = firstRow.dataSource;
      } else if (typeof firstRow.dataSource === 'string') {
        dsObj = (this.props.dsList || []).find((d) => d.datasourceName === firstRow.dataSource || d.name === firstRow.dataSource);
      }
      if (dsObj && dsObj.id) {
        this.props.loadDsDetails(dsObj.id);
        this.setState({selectedDataSource: dsObj});
      }
    }
  }

  handleDataSourceClick = (rowIdx) => {
  // Revert unsaved changes on previous row if any
    if (!this.state.isNewPanelRow && this.panelChanged) {
      const prevRowIdx = this.state.selectedRow;
      const originalRow = this.state.rows[prevRowIdx];
      // If the row has a status of 'saved', reload its original data from localStorage
      if (originalRow && originalRow.status === 'saved') {
        const key = `fieldLineageDraft_${this.state.useCaseName || ''}_${this.state.fieldName || ''}`;
        const draft = localStorage.getItem(key);
        if (draft) {
          const parsed = JSON.parse(draft);
          if (parsed.lineageRows) {
            // Flatten and find the matching row by id
            const flatRows = this.flattenLineageRows(parsed.lineageRows);
            const savedRow = flatRows.find((r) => r.id === originalRow.id);
            if (savedRow) {
              // Replace the unsaved row with the saved row (all fields)
              const restoredRows = this.state.rows.map((row, idx) => idx === prevRowIdx ? {
                ...row,
                dataSource: savedRow.dataSource,
                fieldObj: savedRow.fieldObj,
                source: savedRow.source,
                aliasName: savedRow.aliasName,
                note: savedRow.note,
                isOrigin: savedRow.isOrigin,
              } : row);
              // Also revert the target field of all immediate children
              const parentIndent = this.state.rows[prevRowIdx].indent || 0;
              let i = prevRowIdx + 1;
              while (i < this.state.rows.length && (this.state.rows[i].indent || 0) > parentIndent) {
                if ((this.state.rows[i].indent || 0) === parentIndent + 16) {
                  restoredRows[i] = {...restoredRows[i], target: savedRow.aliasName};
                }
                i++;
              }
              this.setState({
                rows: restoredRows,
                selectedDataSource: savedRow.dataSource || null,
                selectedField: savedRow.fieldObj || null,
                aliasName: savedRow.aliasName || '',
                isOrigin: savedRow.isOrigin || false,
              });
            }
          }
        }
      }
    }
    // Always reset panelChanged when switching rows
    this.panelChanged = false;
    // Get the row object before setState
    const selectedRowObj = this.state.rows && this.state.rows[rowIdx];
    let ds = null;
    if (selectedRowObj && selectedRowObj.dataSource) {
      if (typeof selectedRowObj.dataSource === 'object' && selectedRowObj.dataSource.id) {
        ds = selectedRowObj.dataSource;
      } else {
        ds = (this.props.dsList || []).find((d) => d.datasourceName === selectedRowObj.dataSource || d.name === selectedRowObj.dataSource);
      }
      if (ds && ds.id) {
        // Always trigger API call for dsDetails immediately, before setState
        this.props.loadDsDetails(ds.id);
      }
    }
    // If loading a saved row, populate panel with saved info
    this.setState((prev) => {
      const next = {
        ...prev,
        selectedRow: rowIdx,
        showPanel: true,
        panelRow: rowIdx,
        isNewPanelRow: false,
        dsError: '',
        fieldError: '',
        aliasError: '',
        dsTouched: false,
        fieldTouched: false,
        aliasTouched: false,
      };
      if (ds && ds.id) {
        next.selectedDataSource = ds;
        next.selectedField = selectedRowObj && selectedRowObj.fieldObj ? selectedRowObj.fieldObj : null;
        next.aliasName = selectedRowObj && selectedRowObj.aliasName ? selectedRowObj.aliasName : '';
      } else {
        next.selectedDataSource = null;
        next.selectedField = selectedRowObj && selectedRowObj.fieldObj ? selectedRowObj.fieldObj : null;
        next.aliasName = selectedRowObj && selectedRowObj.aliasName ? selectedRowObj.aliasName : '';
      }
      return next;
    });
  };

  handleAddHop = (rowIdx) => {
    const {rows} = this.state;
    const parent = rows[rowIdx];
    // Calculate indentation: parent's indent + 24, or 24 if no indent
    const parentIndent = parent.indent ? parent.indent : 0;
    const newRow = {
      id: 'n_' + Date.now(),
      source: '',
      target: parent.source,
      dataSource: '',
      fieldObj: null,
      aliasName: '',
      hops: [],
      highlight: true,
      status: null,
      indent: parentIndent + 16,
    };
    const newRows = rows.slice();
    newRows.splice(rowIdx + 1, 0, newRow);
    // Set details panel to this new row, clear all error states and fields
    this.setState((prev) => ({
      ...prev,
      rows: newRows,
      selectedRow: rowIdx + 1,
      showPanel: true,
      panelRow: rowIdx + 1,
      selectedDataSource: null,
      selectedField: null,
      aliasName: '',
      dsError: '',
      fieldError: '',
      aliasError: '',
      dsTouched: false,
      fieldTouched: false,
      aliasTouched: false,
      isNewPanelRow: true,
    }));
  };

  handlePanelClose = () => {
    this.setState((prev) => {
      const next = {...prev, showPanel: false, panelRow: null, selectedRow: null};
      this.saveDraft(next);
      return next;
    });
  };

  handleDataSourceChange(val) {
    // Update selected row's dataSource column with full object
    const {rows, selectedRow} = this.state;
    const updatedRows = rows.map((row, idx) =>
      idx === selectedRow ? {...row, dataSource: val} : row,
    );
    const nextState = {
      ...this.state,
      selectedDataSource: val,
      selectedField: null,
      aliasName: '',
      rows: updatedRows,
      fieldOptionsLoading: true,
    };
    // If editing a new row, remove isNewPanelRow so panel doesn't reset
    if (this.state.isNewPanelRow) nextState.isNewPanelRow = false;
    this.setState(nextState, () => {
      if (val && val.id) {
        this.props.loadDsDetails(val.id);
      }
    });
  }

  handleFieldNameChange = (fieldObj) => {
    this.panelChanged = true;
    this.panelChanged = true;
    if (!fieldObj) return;
    // Prepopulate alias name and update source column in selected row
    const aliasName = fieldObj.name;
    const {rows, selectedRow} = this.state;
    // Save the full field object in a dedicated property
    const updatedRows = rows.map((row, idx) =>
      idx === selectedRow ? {...row, fieldObj, source: aliasName, aliasName} : row,
    );
    // Cascade to immediate children: update their target field
    const parentIndent = rows[selectedRow].indent || 0;
    let i = selectedRow + 1;
    while (i < rows.length && (rows[i].indent || 0) > parentIndent) {
      if ((rows[i].indent || 0) === parentIndent + 16) {
        updatedRows[i] = {...updatedRows[i], target: aliasName};
      }
      i++;
    }
    const next = {...this.state, selectedField: fieldObj, aliasName, rows: updatedRows};
    // If editing a new row, remove isNewPanelRow so panel doesn't reset
    if (this.state.isNewPanelRow) next.isNewPanelRow = false;
    this.setState(next);
  };

  handleAliasNameChange = (e) => {
    this.panelChanged = true;
    const aliasName = e.target.value;
    const {rows, selectedRow} = this.state;
    // Only update aliasName and source, do NOT touch selectedField
    const updatedRows = rows.map((row, idx) =>
      idx === selectedRow ? {...row, aliasName, source: aliasName} : row,
    );
    // Cascade to immediate children: update their target field
    const parentIndent = rows[selectedRow].indent || 0;
    let i = selectedRow + 1;
    while (i < rows.length && (rows[i].indent || 0) > parentIndent) {
      if ((rows[i].indent || 0) === parentIndent + 16) {
        updatedRows[i] = {...updatedRows[i], target: aliasName};
      }
      i++;
    }
    this.setState({aliasName, rows: updatedRows});
  };
  handleOriginChange(event, isChecked) {
    this.panelChanged = true;
    this.panelChanged = false;
    this.panelChanged = false;
    this.panelChanged = false;
    this.setState({isOrigin: isChecked});
  }

  handlePanelSave = () => {
    // Validation before save
    const {selectedDataSource, selectedField, aliasName, isOrigin} = this.state;
    let dsError = ''; let fieldError = ''; let aliasError = '';
    const dsTouched = true; const fieldTouched = true; const aliasTouched = true;
    if (!selectedDataSource || !selectedDataSource.id) dsError = 'Please select a data source.';
    if (!selectedField || !selectedField.id) fieldError = 'Please select a field name.';
    if (!aliasName || aliasName.trim() === '') aliasError = 'Alias name cannot be empty.';
    if (dsError || fieldError || aliasError) {
      this.setState({dsError, fieldError, aliasError, dsTouched, fieldTouched, aliasTouched});
      return;
    }
    // Save only when Save button is clicked in the panel
    try {
      // Mark the selected row as saved
      const {rows, selectedRow, useCaseName, fieldName} = this.state;
      const updatedRows = rows.map((row, idx) => {
        if (idx === selectedRow) {
          let newId = row.id;
          if (typeof newId === 'string' && newId.startsWith('n_')) {
            // Already a new row, keep as is
            newId = newId;
          } else if (typeof newId === 'string' && newId.startsWith('u_')) {
            // Already updated, keep as is
            newId = newId;
          } else {
            // Existing row, prepend 'u_'
            newId = 'u_' + newId;
          }
          // Save note and systemInfo as null if blank
          let noteVal = row.note;
          if (typeof noteVal === 'string' && noteVal.trim() === '') noteVal = null;
          let systemInfoVal = row.systemInfo;
          if (typeof systemInfoVal === 'string' && systemInfoVal.trim() === '') systemInfoVal = null;
          return {...row, status: 'saved', id: newId, note: noteVal, systemInfo: systemInfoVal, isOrigin};
        }
        return row;
      });
      // Build nested hops structure
      const lineageRows = this.nestLineageRows(updatedRows);
      // Save only the nested rows to localStorage
      const lineageJson = {lineageRows};
      localStorage.setItem(getFieldLineageKey(useCaseName, fieldName), JSON.stringify(lineageJson));
      this.setState({rows: updatedRows, snackbarOpen: true, snackbarMsg: 'Saved successfully!', detailsSaved: true, dsError: '', fieldError: '', aliasError: ''}, () => {
        // Log only the nested rows object
      });
    } catch (e) {
      this.setState({snackbarOpen: true, snackbarMsg: 'Error saving changes.'});
    }
  };

  handleSnackbarClose = () => {
    this.setState({snackbarOpen: false});
  };

  render() {
    const {useCaseName, fieldName, rows, selectedRow, showPanel, panelRow} = this.state; // eslint-disable-line no-unused-vars
    const {dsDetails} = this.props;
    let fieldOptions = [];
    // Always show field options for the selected data source
    if (this.state.selectedDataSource && dsDetails && Array.isArray(dsDetails.datasourceCols)) {
      fieldOptions = dsDetails.datasourceCols
          .map((f) => ({
            name: f && typeof f === 'object' && f.name ? f.name : String(f),
            id: f && typeof f === 'object' && f.name ? f.name : String(f),
          }))
          .filter((opt) => opt.name !== 'Not available'); // Don't show 'Not available' in dropdown
    }

    // Always reflect details of the highlighted row
    const panelRowData = (this.state.selectedRow !== null && this.state.selectedRow !== undefined && this.state.rows && this.state.rows.length > 0) ?
      this.state.rows[this.state.selectedRow] :
      null;
    let panelDataSource = null;
    let panelField = null;
    let panelAlias = '';
    let panelIsOrigin = false;
    let showDetails = true;
    if (this.state.selectedRow === null || this.state.panelRow === null) {
      showDetails = false;
    } else if (this.state.isNewPanelRow) {
      // New row: all fields empty, no errors
      panelDataSource = null;
      panelField = null;
      panelAlias = '';
      panelIsOrigin = false;
    } else if (panelRowData) {
      panelDataSource = this.state.selectedDataSource || (panelRowData.dataSource || null);
      panelField = this.state.selectedField || (panelRowData.fieldObj || null);
      if (panelRowData.aliasName && panelRowData.aliasName !== 'Not available') {
        panelAlias = panelRowData.aliasName;
      } else if (panelRowData.source && panelRowData.source !== 'Not available') {
        panelAlias = panelRowData.source;
      }
      panelIsOrigin = !!panelRowData.isOrigin;
    }
    return (
      <div className="app-content-container">
        <div className="page-content select-container in">
          <Row>
            <Col sm={12} xs={12}>
              <div className="page-nav-container">
                <a onClick={() => {
                  // Save current field-lineage state into the correct use case/field in dataLineageList
                  try {
                    const list = JSON.parse(localStorage.getItem('dataLineageList')) || [];
                    // Find the use case by name (or id if available)
                    const useCaseIdx = list.findIndex((l) => l.name === this.state.useCaseName);
                    if (useCaseIdx !== -1) {
                      const lineage = list[useCaseIdx];
                      if (lineage.fields && Array.isArray(lineage.fields)) {
                        const fieldIdx = lineage.fields.findIndex((f) => f.name === this.state.fieldName);
                        if (fieldIdx !== -1) {
                          // Update the field's info (add all lineage info you want to persist)
                          lineage.fields[fieldIdx] = {
                            ...lineage.fields[fieldIdx],
                            hops: this.state.rows.length - 1,
                            modified: new Date().toLocaleString(),
                            alias: this.state.aliasName || this.state.fieldName,
                            lineageRows: this.state.rows, // Save the full lineage rows for this field
                          };
                          list[useCaseIdx] = lineage;
                          localStorage.setItem('dataLineageList', JSON.stringify(list));
                        }
                      }
                    }
                  } catch (e) {}
                  this.props.history.goBack();
                }} className="back-link">
                  <i className="material-icons">arrow_back</i>
                  Back
                </a>
              </div>
              <h2 style={{margin: '75px 0 0 0'}}>
                {useCaseName}  &rarr; {fieldName} - Data Lineage
              </h2>
            </Col>
          </Row>
          <Row>
            <div style={{display: 'flex', width: '100%'}}>
              <div
                className="rounded-card"
                data-testid="field-lineage-graph"
                style={{
                  marginBottom: 32,
                  width: this.state.showPanel ? '75%' : '100%',
                  transition: 'width 0.2s',
                  overflowX: 'auto',
                  minWidth: 0,
                }}
              >
                <table className="table data-table data-lineage-table" style={{minWidth: 800}}>
                  <thead>
                    <tr>
                      <th>Source</th>
                      <th>Target</th>
                      <th>Data Source</th>
                      <th>Actions</th>
                      <th style={{textAlign: 'right', width: 60}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, idx) => {
                      // Find parent row (if any) for this row
                      let parentIdx = -1;
                      // Defensive parent-finding loop
                      if (Array.isArray(rows) && rows.length > 0 && typeof row.indent === 'number') {
                        for (let i = idx - 1; i >= 0; i--) {
                          if ((row.indent || 0) > (rows[i]?.indent || 0)) {
                            parentIdx = i;
                            break;
                          }
                        }
                      }
                      // If parent is collapsed, skip rendering (defensive)
                      if (
                        parentIdx !== -1 &&
      rows[parentIdx] &&
      this.state.collapsedRows &&
      this.state.collapsedRows[rows[parentIdx].id]
                      ) {
                        return null;
                      }
                      return (
                        <tr
                          key={row.id}
                          className={
        idx === 0 ?
          (selectedRow === 0 ? 'parent-row highlight-row' : 'parent-row') :
          (selectedRow === idx ? 'highlight-row' : '')
                          }
                        >
                          <td style={{paddingLeft: row.indent ? row.indent : '8px'}}>
                            {/* Prepend hop number for each nested level, skip parent row */}
                            {row.indent > 0 && (
                              <span className={`visual-identifier colour${Math.floor(row.indent / 16)}`} style={{marginRight: 6}}>
                                {Math.floor(row.indent / 16)}
                              </span>
                            )}
                            {/* Chevron and source text both clickable for expand/collapse */}
                            {idx !== 0 &&
          Array.isArray(rows) &&
          typeof row.indent === 'number' &&
          rows[idx + 1] &&
          typeof rows[idx + 1].indent === 'number' &&
          rows[idx + 1].indent > (row.indent || 0) ? (
            <span style={{cursor: 'pointer'}} onClick={() => this.handleToggleCollapse(idx)}>
              <span
                className="material-icons"
                style={{fontSize: 16, verticalAlign: 'middle', marginRight: 4}}
              >
                {this.state.collapsedRows && this.state.collapsedRows[row.id] ? 'chevron_right' : 'expand_more'}
              </span>
              <span style={{userSelect: 'none'}}>{typeof row.source === 'object' && row.source.name ? row.source.name : row.source}</span>
            </span>
          ) : (
            <>
              {typeof row.source === 'object' && row.source.name ? row.source.name : row.source}
              {row.isOrigin && (
                <span className="badge grey">origin</span>
              )}
            </>
          )}
                          </td>
                          <td style={{fontWeight: idx === 0 ? 700 : 500}}>{row.target}</td>
                          <td>
                            <a
                              href="#"
                              className="lineage-link"
                              style={{color: '#0088AA', fontWeight: 500, textDecoration: 'underline', cursor: 'pointer'}}
                              onClick={(e) => {
                                e.preventDefault(); this.handleDataSourceClick(idx);
                              }}
                            >
                              {row.dataSource ?
            (typeof row.dataSource === 'object' && row.dataSource.name ?
                row.dataSource.name :
                row.dataSource) :
            'Not available'}
                            </a>
                          </td>
                          <td>
                            <a
                              href="#"
                              className="add-hop-link"
                              style={{
                                pointerEvents: row.status === 'saved' && !row.isOrigin ? 'auto' : 'none',
                                opacity: row.status === 'saved' && !row.isOrigin ? 1 : 0.5,
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                if (row.status === 'saved' && !row.isOrigin) this.handleAddHop(idx);
                              }}
                            >
                              <span className="material-icons" style={{fontSize: 20, verticalAlign: 'middle', marginRight: 4}}>add_circle_outline</span>
          Add Hop
                            </a>
                          </td>
                          <td style={{textAlign: 'right', verticalAlign: 'middle'}}>
                            {idx !== 0 && row.target !== this.state.useCaseName && (
                              <div>
                                <IconButton onClick={(e) => this.handleMenuOpen(e, idx)}>
                                  <i className='material-icons'>more_horiz</i>
                                </IconButton>
                                <Menu anchorEl={this.state.menuAnchorEl} open={this.state.menuRowIdx === idx} onClose={this.handleMenuClose}>
                                  <MenuItem className='wl-group-card-menu' onClick={() => this.handleDeleteClick(idx)}>Delete</MenuItem>
                                </Menu>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {/* Render delete modal only once */}
                <Modal
                  open={!!this.state.showDeleteModal}
                  close={this.handleDeleteCancel}
                  confirm={this.handleDeleteConfirm}
                  title="Delete Field"
                  content={
                    <span>
                    Are you sure you want to delete this field lineage row?
                      {this.state.deleteChildCount > 0 && (
                        <>
                          <br />
                          <b>This will also delete {this.state.deleteChildCount} hop{this.state.deleteChildCount > 1 ? 's' : ''} under it.</b>
                        </>
                      )}
                    </span>
                  }
                  primaryButton="Yes"
                  secondaryButton="No"
                />
              </div>
              {/* Side Panel */}
              {showPanel && (
                <div className="details-panel-container">
                  <div className="details-panel-header">
                    <h3 style={{margin: 0}}>Details Panel</h3>
                    <span
                      className="material-icons"
                      style={{cursor: 'pointer', fontSize: 24}}
                      onClick={this.handlePanelClose}
                    >close</span>
                  </div>
                  <div className="details-panel-content">
                    {!showDetails ? (
                      <div className='description'>
                        Details are not available. Select a row to view/edit details.
                      </div>
                    ) : (
                      <>
                        <div style={{marginBottom: 16}}>
                          <OneOptAutocomplete
                            label="Select data source"
                            fileColumns={(this.props.dsList || []).map((ds) => ({
                              id: ds.datasourceId || ds.id,
                              name: ds.datasourceName || ds.name,
                              ...ds,
                            }))}
                            onSelectValue={(val) => {
                              this.handleDataSourceChange(val);
                              this.setState({dsTouched: true});
                            }}
                            value={panelDataSource}
                            onBlur={() => this.setState({dsTouched: true})}
                          />
                          {this.state.dsTouched && (!panelDataSource || !panelDataSource.id) && this.state.dsError ? (
                            <div style={{color: 'red', fontSize: 13, marginTop: 4}}>{this.state.dsError}</div>
                          ) : null}
                        </div>
                        <div style={{marginBottom: 16}}>
                          <OneOptAutocomplete
                            label="Field name"
                            fileColumns={fieldOptions}
                            onSelectValue={(val) => {
                              this.handleFieldNameChange(val);
                              this.setState({fieldTouched: true});
                            }}
                            value={panelField}
                            disabled={fieldOptions.length === 0 && (!panelField || !panelField.id)}
                            onBlur={() => this.setState({fieldTouched: true})}
                          />
                          {this.state.fieldTouched && (!panelField || !panelField.id) ? (
                            <div style={{color: 'red', fontSize: 13, marginTop: 4}}>Please select a field name.</div>
                          ) : null}
                        </div>
                        <div style={{marginBottom: 16}}>
                          <label style={{fontWeight: 500, marginBottom: 4, display: 'block'}}>Alias name</label>
                          <Input
                            value={panelAlias}
                            onChange={(e) => {
                              this.handleAliasNameChange(e);
                              this.setState({aliasTouched: true});
                            }}
                            onBlur={() => this.setState({aliasTouched: true})}
                            placeholder="Name here"
                            fullWidth
                            disableUnderline={false}
                          />
                          {this.state.aliasTouched && (!panelAlias || panelAlias.trim() === '') && this.state.aliasError ? (
                            <div style={{color: 'red', fontSize: 13, marginTop: 4}}>{this.state.aliasError}</div>
                          ) : null}
                        </div>
                        <div style={{marginBottom: 16}}>
                          <label style={{fontWeight: 500, marginBottom: 4, display: 'block'}}>System Info</label>
                          <Input
                            value={panelRowData && typeof panelRowData.systemInfo === 'string' ? panelRowData.systemInfo : ''}
                            onChange={(e) => {
                              this.panelChanged = true;
                              const systemInfoVal = e.target.value;
                              const {rows, selectedRow} = this.state;
                              const updatedRows = rows.map((row, idx) =>
                                idx === selectedRow ? {...row, systemInfo: systemInfoVal === '' ? null : systemInfoVal} : row,
                              );
                              this.setState({rows: updatedRows});
                            }}
                            placeholder="Enter system info"
                            multiline
                            rows={2}
                            fullWidth
                            disableUnderline={false}
                          />
                        </div>
                        <div style={{marginBottom: 16}}>
                          <label style={{fontWeight: 500, marginBottom: 4, display: 'block'}}>Note</label>
                          <Input
                            value={panelRowData && typeof panelRowData.note === 'string' ? panelRowData.note : ''}
                            onChange={(e) => {
                              this.panelChanged = true;
                              const noteVal = e.target.value;
                              const {rows, selectedRow} = this.state;
                              const updatedRows = rows.map((row, idx) =>
                                idx === selectedRow ? {...row, note: noteVal === '' ? null : noteVal} : row,
                              );
                              this.setState({rows: updatedRows});
                            }}
                            placeholder="Enter description"
                            multiline
                            rows={2}
                            fullWidth
                            disableUnderline={false}
                          />
                        </div>
                        <div style={{marginBottom: 16, display: 'flex', alignItems: 'center'}}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={panelIsOrigin}
                                onChange={(e, checked) => {
                                  this.panelChanged = true;
                                  const {rows, selectedRow} = this.state;
                                  const updatedRows = rows.map((row, idx) =>
                                    idx === selectedRow ? {...row, isOrigin: checked} : row,
                                  );
                                  this.setState({isOrigin: checked, rows: updatedRows});
                                }}
                                color="primary"
                              />
                            }
                            label="Mark it as origin"
                            style={{marginLeft: -8, fontWeight: 500}}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="details-panel-footer">
                    <Button
                      label="Save"
                      className="btn btn-action"
                      onClick={this.handlePanelSave}
                      disabled={(!this.state.isNewPanelRow && !this.panelChanged)}
                    />
                  </div>
                </div>
              )}
            </div>
          </Row>
        </div>
        <Snackbar
          open={this.state.snackbarOpen}
          message={this.state.snackbarMsg}
          autoHideDuration={2000}
          className="snack-bar"
          onClose={this.handleSnackbarClose}
        />
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  dsList: state.commonReducer && state.commonReducer.dsList,
  dsDetails: state.commonReducer && state.commonReducer.dsDetails,
});

export default connect(mapStateToProps, {loadDsList, loadDsDetails})(FieldLineage);
